import o from"styled-components";import{theme as r}from"../../../../../theme.js";const i=o.div`
  display: flex;
  gap: ${r.spacing*2}px;
  flex-wrap: wrap;
`,e=o.div`
  display: flex;
  align-items: center;
  gap: ${r.spacing*12}px;
  border-radius: ${r.radius}px;
  padding: ${r.spacing*2}px;
  background-color: ${r.colors.gray[50]};
  > span {
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
    color: ${r.colors.gray[500]};
  }
  > button {
    border: none;
    cursor: pointer;
    background-color: unset;
    padding: 0;
    > svg {
      width: 18px;
      height: 18px;
      > g, path {
        fill: ${r.colors.error[300]};
      }
    }
  }
  &.showMore {
    cursor: pointer;
  }
`;export{i as Container,e as TagContainer};
